import { AI_API_SERVICE } from '@eggplant/api-hosts'
import { AuthenticatedDataRequest } from '@eggplant/data-request'
import type { ReactElement } from 'react'

interface Props {
  id: string
  onSuccess?: () => void
  children?: () => ReactElement
}

const DeleteAiRunRequest = ({
  id,
  onSuccess,
  children
}: Props) => {
  const url = `${AI_API_SERVICE}/runs/${id}`

  return (
    <AuthenticatedDataRequest
      children={children}
      method='delete'
      onSuccess={onSuccess}
      url={url}
    />
  )
}

export default DeleteAiRunRequest
